import React from 'react';

/** Form separator div, purely cosmetic */
export default function Separator() {
  return (
    <div className="m-form__seperator m-form__seperator--dashed m-form__seperator--space-2x" />
  );
}
